import React from 'react';
import { FaPhone, FaEnvelope, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Contact Us Section */}
        <div className={styles.footerSection}>
          <h3 className={styles.sectionTitle}>Contact us</h3>
          <div className={styles.contactInfo}>
           
            <div className={styles.contactItem}>
              <FaPhone className={styles.contactIcon} />
              <a href="tel:+919156091640">+91 9156091640</a>
            </div>
            <div className={styles.contactItem}>
              <FaEnvelope className={styles.contactIcon} />
              <a href="mailto:customerservice@propertyplateau.com">customerservice@propertyplateau.com</a>
            </div>
          </div>
          
          <div className={styles.socialMedia}>
            <h4 className={styles.socialTitle}>Property Plateau</h4>
            <div className={styles.socialIcons}>
              <a href="https://www.facebook.com/people/Propertyplateau-Realty/" aria-label="Facebook" className={styles.socialLink}>
                <FaFacebook className={styles.socialIcon} />
              </a>
              <a href="https://www.instagram.com/property_plateau/" aria-label="Instagram" className={styles.socialLink}>
                <FaInstagram className={styles.socialIcon} />
              </a>
              <a href="https://www.linkedin.com/company/propertyplateau-realty/" aria-label="LinkedIn" className={styles.socialLink}>
                <FaLinkedin className={styles.socialIcon} />
              </a>
            </div>
          </div>
        </div>

        {/* Lists by Category Section */}
        <div className={styles.footerSection}>
          <h3 className={styles.sectionTitle}>Lists by Category</h3>
          <ul className={styles.categoryList}>
            {['Apartments (942)', 'Houses (4)', 'Independent House (10)', 'Land (54)', 'Luxury Property (3)', 
              'Office Spaces (44)', 'Plot (99)', 'Residential property (10)', 'Row Villas (68)', 'Shops (32)',
              'Showrooms (17)', 'Villa (80)', 'Villas (4)', 'Warehouse (4)'].map((item, index) => (
              <li key={index} className={styles.categoryItem}>
                <a href="#" className={styles.categoryLink}>{item}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Company Section */}
        <div className={styles.footerSection}>
          <h3 className={styles.sectionTitle}>Company</h3>
          <ul className={styles.companyList}>
            {[
              {text: 'About Us', link: '/about-us'},
              {text: 'Careers', link: '/careers'},
              {text: 'Contact Us', link: '/contactus'},
              {text: 'Services', link: '/service'},
              {text: 'Our Brand', link: '/brand'},
              {text: 'Property Details', link: '/property/sample-slug'},
              {text: 'NRI Guide', link: '/NRI-guide'},
              {text: 'Lease With Us', link: '/Lease-with-us'},
              {text: 'Facility Management', link: '/Facility-Management'},
              {text: 'Painting Services', link: '/painting-services'},
              {text: 'Real Estate Investment', link: '/Invest-real'}
            ].map((item, index) => (
              <li key={index} className={styles.companyItem}>
                <a href={item.link} className={styles.companyLink}>{item.text}</a>
              </li>
            ))}
          </ul>
          
          <h3 className={styles.sectionTitle}>Latest Properties</h3>
          <ul className={styles.propertiesList}>
            {[
              {name: 'Centerpoint by Nutan Groups – Boath...', price: 'Starting 79 Lakhs'},
              {name: 'Codename Golden Triangle', price: 'Starting 44.9° Lakhs'},
              {name: 'Ayodhya The Sarayu Serve', price: 'Starting 1.59 Cr'}
            ].map((property, index) => (
              <li key={index} className={styles.propertyItem}>
                <a href="#" className={styles.propertyLink}>
                  <span className={styles.propertyName}>{property.name}</span>
                  <span className={styles.propertyPrice}>{property.price}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

       
      </div>
      
      {/* Copyright Section */}
      <div className={styles.copyright}>
        <div className={styles.copyrightContent}>
          &copy; {new Date().getFullYear()} Property Plateau. All Rights Reserved.
          <div className={styles.legalLinks}>
            <a href="/privacy-policy" className={styles.legalLink}>Privacy Policy</a>
            <a href="/terms-of-service" className={styles.legalLink}>Terms of Service</a>
            <a href="/sitemap" className={styles.legalLink}>Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;